module.exports = __webpack_public_path__ + "img/5.0565f532.webp";